<script>
export default {
  name: 'ComprehensiveApproach',
  components: {
  },
  data () {
    return {
      isMounted: false
      // images: [
      //   {
      //     mobile: './img/visual_closure_vid@0.25x.png',
      //     tablet: './img/visual_closure_vid@0.25x.png',
      //     desktop: './img/visual_closure_vid@0.25x.png',
      //     widescreen: './img/visual_closure_vid@0.25x.png',
      //     fullhd: './img/visual_closure_vid@0.25x.png',
      //     fallback: './img/visual_closure_vid@0.25x.png'
      //   },
      //   {
      //     srcSet: 'img/promo/home/comprehensiveApproach//visual_closure_vid@0.25x.png 768w, img/promo/home/comprehensiveApproach//visual_closure_vid@0.5x.png 1025w'
      //   }
      // ]
    }
  },
  computed: {
    images () {
      return [
        {
          srcSet: 'img/promo/home/comprehensiveApproach/visual_closure_game@0.33x.png 100w, img/promo/home/comprehensiveApproach/visual_closure_game@0.5x.png 1025w'
        },
        {
          srcSet: 'img/promo/home/comprehensiveApproach/visual_closure_wksheet@0.33x.png 100w, img/promo/home/comprehensiveApproach/visual_closure_wksheet@0.5x.png 1025w'
        },
        {
          srcSet: 'img/promo/home/comprehensiveApproach/visual_closure_vid@0.33x.png 100w, img/promo/home/comprehensiveApproach/visual_closure_vid@0.5x.png 1025w'
        }
      ]
    },
    vidLibImg () {
      return [
        {
          srcSet: 'img/promo/home/comprehensiveApproach/vidLib_pr@0.33x.png 100w, img/promo/home/comprehensiveApproach/vidLib_pr@0.5x.png 1025w'
        },
        {
          srcSet: 'img/promo/home/comprehensiveApproach/vidLib_coach@0.33x.png 100w, img/promo/home/comprehensiveApproach/vidLib_coach@0.5x.png 1025w'
        },
        {
          srcSet: 'img/promo/home/comprehensiveApproach/vidLib_kim@0.33x.png 100w, img/promo/home/comprehensiveApproach/vidLib_kim@0.5x.png 1025w'
        },
        {
          srcSet: 'img/promo/home/comprehensiveApproach/vidLib_wm@0.33x.png 100w, img/promo/home/comprehensiveApproach/vidLib_wm@0.5x.png 1025w'
        }
      ]
    },
    worksheetImg () {
      return [
        {
          srcSet: 'img/promo/home/comprehensiveApproach/wksht_01@0.5x.png 100w, img/promo/home/comprehensiveApproach/wksht_01@0.5x.png 1025w'
        },
        {
          srcSet: 'img/promo/home/comprehensiveApproach/wksht_02@0.5x.png 100w, img/promo/home/comprehensiveApproach/wksht_02@0.5x.png 1025w'
        },
        {
          srcSet: 'img/promo/home/comprehensiveApproach/wksht_03@0.5x.png 100w, img/promo/home/comprehensiveApproach/wksht_03@0.5x.png 1025w'
        }
      ]
    },
    screenSize () {
      return this.$mq
    }
  },
  methods: {
  },
  mounted () {
    this.isMounted = false
  }
}
</script>
<template>
  <section class="comprehensive-approach article-body">
    <article class="">
      <header class="">
        <h2 class="article-title mb-2">Comprehensive Approach</h2>
        <div class="article-subtitle">Round out your treatment plan with corresponding worksheets and videos.</div>
      </header>
      <div class="article-body mt-4">
        Our Activities, Worksheets, and Video libraries are tagged, filterable, and searchable by therapy type (among other things).<br>
        It's easy to find and assign the right Worksheets and Videos to compliment your treatment plan.
      </div>
      <section class="mt-5">
        <header>
          <h3 class="article-section-title">Video Library</h3>
          <p class="article-section-sub-title mt-1">
            Add movement to your treatment plan.
          </p>
        </header>
        <div class="video-grid mt-3">
          <div class="video-grid-item">
            <b-image
              class="video-grid-item-image"
              src="/img/promo/home/comprehensiveApproach/primitive_reflexes@0.33x.avif"
              src-fallback="/img/promo/home/comprehensiveApproach/primitive_reflexes@0.33x.png"
              responsive
              ratio="422by238"
              alt="Primitive Reflexes video library screenshot"
            />
            <div class="video-grid-item-content">
              <h4 class="article-section-sub-title">
                Primitive Reflexes
              </h4>
              <p class="article-body">
                Professional PR videos created by Patricia Andrich, COVT, OTR/L
              </p>
            </div>
          </div>
          <div class="video-grid-item">
            <b-image
              class="video-grid-item-image"
              src="/img/promo/home/comprehensiveApproach/ovb-coach@0.33x.avif"
              src-fallback="/img/promo/home/comprehensiveApproach/ovb-coach@0.33x.png"
              responsive
              ratio="422by238"
              alt="OVB Coach video library screenshot"
            />
            <div class="video-grid-item-content">
              <h4 class="article-section-sub-title">
                OVB Coach
              </h4>
              <p class="article-body">
                Demonstrating how to use therapy equipment and other therapeutic activities at home.
              </p>
            </div>
          </div>
          <div class="video-grid-item">
            <b-image
              class="video-grid-item-image"
              src="/img/promo/home/comprehensiveApproach/we_move@0.33x.avif"
              src-fallback="/img/promo/home/comprehensiveApproach/we_move@0.33x.png"
              responsive
              ratio="422by238"
              alt="We Move video library screenshot"
            />
            <div class="video-grid-item-content">
              <h4 class="article-section-sub-title">
                We Move
              </h4>
              <p class="article-body">
                Fun tutorials focusing on using common household objects to work on perceptual skills.
              </p>
            </div>
          </div>
          <div class="video-grid-item">
            <b-image
              class="video-grid-item-image"
              src="/img/promo/home/comprehensiveApproach/kids_in_motion@0.33x.avif"
              src-fallback="/img/promo/home/comprehensiveApproach/kids_in_motion@0.33x.png"
              responsive
              ratio="422by238"
              alt="Kids In Motion video library screenshot"
            />
            <div class="video-grid-item-content">
              <h4 class="article-section-sub-title">
                Kids In Motion
              </h4>
              <p class="article-body">
                Professional Pilates videos demonstrating how to perform various movements focusing on core and balance.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section class="mt-5">
        <header>
          <h3 class="article-section-title">Worksheets Library</h3>
          <p class="article-section-sub-title mt-1">
            Download Worksheets for all ages and abilities.
          </p>
        </header>
        <div class="worksheet-grid mt-3">
          <b-image
            class="worksheet-grid-image"
            src="img/promo/home/comprehensiveApproach/wksht_01@0.5x.avif"
            src-fallback="/img/promo/home/comprehensiveApproach/wksht_01@0.5x.png"
            responsive
            ratio="317by245"
            alt="Worksheet example screenshot"
          />
          <b-image
            class="worksheet-grid-image"
            src="img/promo/home/comprehensiveApproach/wksht_02@0.5x.avif"
            src-fallback="/img/promo/home/comprehensiveApproach/wksht_02@0.5x.png"
            responsive
            ratio="317by245"
            alt="Worksheet example screenshot"
          />
          <b-image
            class="worksheet-grid-image"
            src="img/promo/home/comprehensiveApproach/wksht_03@0.5x.avif"
            src-fallback="/img/promo/home/comprehensiveApproach/wksht_03@0.5x.png"
            responsive
            ratio="317by245"
            alt="Worksheet example screenshot"
          />
          <b-image
            class="worksheet-grid-image"
            src="img/promo/home/comprehensiveApproach/wksht_04@0.5x.avif"
            src-fallback="/img/promo/home/comprehensiveApproach/wksht_04@0.5x.png"
            responsive
            ratio="317by245"
            alt="Worksheet example screenshot"
          />
        </div>
      </section>
    </article>
  </section>
</template>
<style lang="scss">
  .comprehensive-approach .video-grid{
    .b-image-wrapper > img.has-ratio {
      border-top-left-radius: 0.5rem;
      border-top-right-radius: 0.5rem;
    }
  }
</style>
<style scoped lang="scss">
.comprehensive-approach {
  display: block;
  //background-image: linear-gradient(to right, #F5EBDC, $eggshell);
  .worksheet-lib-list {
    display: flex;
    flex-wrap: wrap;
    .worksheet-lib-item {
      width: 14rem;
      margin-bottom: 1rem;
      &:not(:last-child) {
        margin-right: 1rem;
      }
    }
    .worksheet-lib-item-image {
      width: 14rem;
      box-shadow: rgba(0, 0, 0, 0.05) 0 5px 20px;
    }
  }
  .worksheet-grid {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-column-gap: 2rem;
    grid-row-gap: 1rem;
    &-image {
      box-shadow: rgba(0, 0, 0, 0.1) 0 10px 50px;
    }
  }
  .video-grid {
    display: grid;
    grid-template-columns: 1fr;
    grid-column-gap: 2rem;
    grid-row-gap: 1rem;
    @include tablet {
      grid-template-columns: 1fr 1fr;
    }
    @include desktop {
      grid-template-columns: 1fr 1fr 1fr 1fr;
    }
    & .video-grid-item {
      box-shadow: rgba(0, 0, 0, 0.1) 0 10px 50px;
      border-radius: 0.5rem;
      @include tablet {
      }
      @include desktop {
      }
      &-content {
        padding: 1rem;
      }
    }
  }
  .video-lib-list {
    display: flex;
    flex-wrap: wrap;
    @include tablet {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-column-gap: 2rem;
      grid-row-gap: 1rem;
    }
    .video-lib-item {
      display: flex;
      flex-grow: 1;
      flex-direction: row;
      align-items: flex-start;
      margin-bottom: 1rem;
      &:not(:last-child) {
        margin-right: 1rem;
      }
      @include tablet {
        //max-width: 25rem;
        //align-items: center;
      }
      @include widescreen {
        //padding: 1rem;
        //max-width: 25rem;
      }
    }
    .vid-lib-item-image {
      min-width: 6rem;
      @include tablet {
        min-width: 13rem;
      }
      @include desktop {
        min-width: 20rem;
      }
      @include widescreen {
        min-width: 20rem;
      }
    }
    .vid-lib-item-content {
      margin-left: 0.5rem;
      @include widescreen {
        margin-left: 1rem;
      }
    }
  }
  .visual-closure {
    &-container {
      background-color: $empty-background;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      padding: 1rem;
      border-radius: 0.5rem;
      @include tablet {
        justify-content: flex-start;
      }
    }
    &-image {
      width: 12rem;
      &:not(:last-child) {
        margin-bottom: 1rem;
      }
      figcaption {
        text-align: center;
        font-weight: $font-semibold;;
        color: $feldgrau;
        margin: 0;
        padding: 0;
        font-size: $size-6;
      }
      @include tablet {
        width: 14rem;
        &:not(:last-child) {
          margin-bottom: 0;
          margin-right: 1rem;
        }
      }
    }

  }
}
</style>
